import React, { useState, useEffect } from 'react';
import './carousel.css';
import { carouselImages } from '../../json/carouselImages';
import Serch from '../Serch/Serch';

const Carousel = ({ bannerData, serch, name }) => {
  const [miImages, setMiImages] = useState([]);

  useEffect(() => {
    setMiImages(bannerData);
  }, [bannerData]);

  return (
    <div id={name} className="carousel slide carouselBos" data-bs-ride="carousel">
      
      {/* 1. CONTENEDOR DE IMÁGENES */}
      <div className="carousel-inner">
        {miImages.map((item, index) => (
          <div 
            key={index} 
            className={index === 0 ? "carousel-item active" : "carousel-item"}
          >
            <a href={item.url} target="_blank" rel="noreferrer">
              {/* CAMBIO: Usamos etiqueta IMG real para que se ajuste sola */}
              <img 
                src={item.imagen} 
                className="d-block w-100 banner-img-real" 
                alt={`Slide ${index}`} 
              />
            </a>
          </div>
        ))}
      </div>

      {/* 2. CONTENEDOR DEL BUSCADOR (FUERA DEL INNER) */}
      {/* Esto asegura que flote encima y no se corte en los bordes */}
      {serch && (
        <div className="search-overlay">
          {/* El componente Serch debe ser limpio, sin position absolute interno */}
          <Serch />
        </div>
      )}

      {/* 3. BOTONES DE CONTROL */}
      <button className="carousel-control-prev" type="button" data-bs-target={'#' + name} data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target={'#' + name} data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>

    </div>
  );
}

export default Carousel;